import React from 'react'

import classes from './index.module.scss'

export const NotFound = (): JSX.Element => {
  return (
    <>
      <div className={classes.header_wrapper}></div>
      <div className={classes.wrapper}>
        <h1>404</h1>
        <span>Страница не найдена</span>
      </div>
    </>
  )
}
